import React, { useState, useEffect } from "react";
import MainLayout from "../layout/MainLayout";
import { useNavigate } from 'react-router-dom';

import axios from "axios";

function ContactPage() {

  let navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const onChangeName = (e) => {
    const name = e.target.value;
    setName(name);
  };
  const onChangeSubject = (e) => {
    const subject = e.target.value;
    setSubject(subject);
  };
  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };
  const onChangeMessage = (e) => {
    setMessage(e.target.value);
  };

  const handleSubmit = (e) => {

    let tmpData = JSON.stringify({
      name: name,
      email: email,
      subject: subject,
      message: message
    });

    axios.post("/api/v1/sendMessage", tmpData, {
      headers: { 'Content-type': 'application/json' }
    })
      .then((response) => {
        if (response.status === 200) {
          alert("Your message was sent");
        } else {
          alert("There was a problem with your request. Please try again later.");
        }
        navigate("/");
      })
      .catch((err) => {
        if (err.response.status === 401) {
          alert("There was a problem with your request. Please try again later.");
        }
      });
  };


  return (
    <MainLayout>
      <title>Contact RSBS</title>
      <div className="table-data">
        <p>Use the form below to send us a message. </p>
        <br />
        <br />
        <form action={handleSubmit}>
          <div className="table-row">
            <label>Name</label>
            <input name="name" type="text" size="50" required onChange={onChangeName} />
          </div>

          <div className="table-row">
            <label>Email</label>
            <input name="email" type="text" size="50" required onChange={onChangeEmail} />
          </div>

          <div className="table-row">
            <label>Subject</label>
            <input name="subject" type="text" size="50" required onChange={onChangeSubject} />
          </div>

          <div className="table-row">
            <label>Message</label><br />
            <textarea rows="8" name="message" onChange={onChangeMessage} />
          </div>

          <br /><br />
          <input type="submit" />

        </form>
      </div>
    </MainLayout>
  );
}

export default ContactPage;
